import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getScottsdaleStructuredData() {
  const url = "https://restorehair.com/locations/arizona/scottsdale/";
  const description =
    "Find out about your hair transplant options in Scottsdale with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("scottsdale", url, description),
    locationPageCrumbs(url, "Scottsdale"),
  ];
}
